module.exports = new __parcel__URL__("sea-ice--discovery-cover.769454dc.jpg").toString();